<template>
  <div>
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="4">
            <BaseInputValidation
              :disabled="hasPermissionToEdit || view"
              v-mask="['###.###.###-##']"
              id="employee_number"
              name="CPF *"
              v-model="form.employee_number"
              rules="employerNumber|required"
              :loading="loading"
            ></BaseInputValidation>
          </v-col>
          <v-col cols="4">
            <BaseInputValidation
              :disabled="hasPermissionToEdit || view"
              id="name"
              name="Nome *"
              rules="required"
              v-model="form.name"
              :loading="loading"
            ></BaseInputValidation>
          </v-col>
          <v-col cols="4">
            <BaseInputValidation
              :disabled="hasPermissionToEdit || view"
              id="nickname"
              name="Nome Resumo(Apelido) *"
              v-model="form.nickname"
              rules="required"
              :loading="loading"
            ></BaseInputValidation>
          </v-col>
          <v-col cols="6">
            <BaseInputValidation
              :disabled="hasPermissionToEdit || view"
              id="occupation"
              name="Cargo/Função *"
              rules="required"
              v-model="form.occupation"
              :loading="loading"
            ></BaseInputValidation>
          </v-col>
          <v-col cols="4">
            <BaseInputValidation
              :disabled="hasPermissionToEdit || view"
              id="email"
              name="Email *"
              rules="required|email"
              v-model="form.email"
              :loading="loading"
            ></BaseInputValidation>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <BaseInputValidation
              :disabled="view"
              id="phone_number"
              name="Telefone *"
              rules="required|min:13"
              v-model="form.phone_number"
              v-mask="['(##)####-####', '(##)#####-####']"
              :loading="loading"
            ></BaseInputValidation>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import BaseInputValidation from "../../../../components/UI/BaseInputValidation";
import { mask } from "vue-the-mask";

export default {
  directives: { mask },
  components: {
    BaseInputValidation
  },
  data: () => ({
    form: {
      employee_number: "",
      name: "",
      nickname: "",
      occupation: "",
      email: "",
      phone_number: ""
    }
  }),
  props: {
    register: {
      type: Object
    },
    view: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    hasPermissionToEdit: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    form: {
      handler(newVal) {
        this.$emit("setFields", {
          data: newVal
        });
      },
      deep: true
    },
    register() {
      this.form = Object.assign(this.form, this.register);
    }
  }
};
</script>
